/**
 * 0 - Магазины партнеров
 * 1 - Магазины vip партнеров
 * 2 - Фирменные магазины
 */
export const SHOP_TYPE = {
    PARTNER: 0,
    VIP_PARTNER: 1,
    BRANDED: 2,
} as const;

export type ShopType = typeof SHOP_TYPE[keyof typeof SHOP_TYPE];

export type Shop = {
    address: string;
    city: string;
    id: number;
    metro: string;
    name: string;
    operating_mode: string;
    phone: string;
    targetx: number;
    targety: number;
    tip: ShopType;
}
